/**
 * Minimal user-agent parser for the sessions table.
 * Returns a friendly "Browser on OS" string; falls back to "Unknown device".
 */

export function parseUserAgent(ua: string | null | undefined): string {
  if (!ua) return "Unknown device";

  const browsers: Array<[string, RegExp]> = [
    ["Chrome", /Chrome\/[\d.]+/],
    ["Edge", /Edg\/[\d.]+/],
    ["Firefox", /Firefox\/[\d.]+/],
    ["Safari", /Version\/[\d.]+ Safari\//],
    ["Curl", /^curl\//i],
  ];
  const oses: Array<[string, RegExp]> = [
    ["macOS", /Macintosh/],
    ["Windows", /Windows NT/],
    ["Linux", /Linux/],
    ["iOS", /iPhone|iPad/],
    ["Android", /Android/],
  ];

  const browser = browsers.find(([, re]) => re.test(ua))?.[0] ?? "Unknown browser";
  const os = oses.find(([, re]) => re.test(ua))?.[0] ?? "";
  return os ? `${browser} on ${os}` : browser;
}
